import App from './App';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import reduxThunk from "redux-thunk";
import reducers from './stores/reducers';
import { datadogRum } from '@datadog/browser-rum';

datadogRum.init({
    applicationId: '3b33c4b4-a2ec-4498-b627-ed636cb2cfd8',
    clientToken: 'pub61e3b881ab9802d4d1b98882882c5b3c',
    site: 'datadoghq.com',
    service: 'oa-daolinvestment',
    env: 'ktbst-group-nonprod',
    // Specify a version number to identify the deployed version of your application in Datadog 
    // version: '1.0.0', 
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
});

const store = createStore(reducers, {}, applyMiddleware(reduxThunk));

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);
